import { definirWorkerDePdf } from '@mymaxx/ui';
import workerDePdf from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1 } } });

/**
 * Versão nova no ar: a aba recarrega sozinha.
 *
 * O app é PWA com `autoUpdate`, então o service worker novo baixa e assume sozinho — mas a
 * página que já está aberta continua rodando os arquivos antigos até alguém recarregar. Na
 * prática o cliente ficava com a versão de ontem sem saber, e uma correção só chegava a
 * ele quando fechasse o navegador. Foi assim que uma correção de login pareceu não ter
 * subido, com o servidor já servindo a versão certa.
 *
 * O `recarregando` evita o laço: sem ele, um service worker que assuma durante o
 * carregamento faria a página recarregar sem parar.
 */
if ('serviceWorker' in navigator) {
  let recarregando = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recarregando) return;
    recarregando = true;
    window.location.reload();
  });
}

// A prévia de PDF precisa saber onde está o worker do pdf.js, e só o empacotador sabe.
// Fica aqui, uma vez, porque `@mymaxx/ui` compila com tsc puro e não entende o `?url` do Vite.
definirWorkerDePdf(workerDePdf);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
